export class CurrentFilterDataService {
  constructor(
    $q,
    FilterDataFactory,
    FiltersService,
    CurrentModelService,
    AggregateDataService,
    ErrorHandlerService,
    CurrentFilterService,
    $timeout,
    $rootScope,
  ) {
    this.FiltersService = FiltersService;
    this.CurrentModelService = CurrentModelService;
    this.AggregateDataService = AggregateDataService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentFilterService = CurrentFilterService;
    this.$q = $q;
    this.filterData = FilterDataFactory();
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.autoUpdate = true;
    this.needReload = false;
  }

  get filter() {
    return this.CurrentFilterService.filter;
  }

  get filterBar() {
    return this.CurrentFilterService.filterBar;
  }

  reload(force) {
    //console.log("reload, cache: " + !resetCache);
    const reload = [];
    if (this.autoUpdate || force ||
      this.CurrentFilterService.filterBar.drilldown[0] !==
      this.AggregateDataService.barDim) {
      reload.push(this.AggregateDataService.init(false));
    }
    if ((this.autoUpdate || force) && !this.CurrentFilterService.frameUrl) {
      reload.push(this.filterData.update(this.filter, force));
      this.needReload = false;
    } else {
      this.needReload = true;
    }
    return this.$q.all(reload)
      .catch((error) => {
        this.ErrorHandlerService.handle(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/core/current-filter-data.service.js